import React from 'react';

const TextareaField = ({ label, value, onChange, placeholder, maxLength = 500, hint }) => {
  const count = value?.length || 0;

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium text-foreground">{label}</label>
        <span className={`text-xs ${count > maxLength * 0.9 ? 'text-warning' : 'text-muted-foreground'}`}>
          {count}/{maxLength}
        </span>
      </div>
      {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
      <textarea
        value={value || ''}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={4}
        className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-y"
      />
    </div>
  );
};

const TextosTab = ({ form, onChange }) => {
  return (
    <div className="space-y-6">
      <TextareaField
        label="Pie de página"
        value={form?.footer_text}
        onChange={(v) => onChange('footer_text', v)}
        placeholder="Ej. Verdi Llantas — Taller Mecánico Automotriz | Tel: 2293698695"
        maxLength={300}
        hint="Texto que aparece en el pie de todos los documentos."
      />
      <TextareaField
        label="Texto legal"
        value={form?.legal_text}
        onChange={(v) => onChange('legal_text', v)}
        placeholder="Aviso legal, términos de uso, etc."
        maxLength={1000}
        hint="Leyenda legal que aparece en documentos oficiales."
      />
      <TextareaField
        label="Términos de cotización"
        value={form?.quote_terms}
        onChange={(v) => onChange('quote_terms', v)}
        placeholder="Ej. Precios sujetos a cambio sin previo aviso. Cotización válida por 15 días."
        maxLength={500}
        hint="Condiciones que aplican a todas las cotizaciones."
      />
      <TextareaField
        label="Garantía"
        value={form?.warranty_text}
        onChange={(v) => onChange('warranty_text', v)}
        placeholder="Ej. Garantía en mano de obra: 30 días o 3,000 km, lo que ocurra primero."
        maxLength={500}
        hint="Texto de garantía que aparece en órdenes de trabajo y notas de venta."
      />
    </div>
  );
};

export default TextosTab;
